module.exports = __webpack_public_path__ + "img/media.c55e919a.png";